import HCRender from "aldoo-ra/HelpCenter/hc-render"

const FeaturedContent = () => {
  const PopularCategories = HCRender.getFragment("PopularCategories")
  const FeaturedCategories = HCRender.getFragment("FeaturedCategories")

  return (
    <div className="relative w-full max-w-w2_xl space-y-12">
      {PopularCategories && <PopularCategories />}
      {FeaturedCategories && <FeaturedCategories />}
    </div>
  )
}

export default FeaturedContent
